import { refreshRequest, getRealm } from '../utils/host';
import env from '../env';
import settings from '../settings';

/**
 * Check if user is authenticated by verifying httpOnly cookie on backend
 * @returns {Promise<Object>} Authentication status and user data
 */
export const checkAuthentication = async () => {
    try {
        const isDevEnv = env.APP_ENV === 'development';
        const realm = getRealm() || 'xyz';

        if (isDevEnv) {
            let token = localStorage.getItem(settings.getLocalTokenName());
            return { isAuthenticated: !!token, [`${realm}_los_token`]: token || "" };
        }

        const response = await refreshRequest.get(
            `${env['API_HOST']}/auth/sp/isAuthenticated`,
            { 
                withCredentials: true,
                headers: {
                    'Origin': window.location.origin
                }
            }
        );

        const authResult = response.data;

        // Set token in settings if authenticated
        if (authResult.isAuthenticated && authResult[`${realm}_los_token`]) {
            window.los_token = authResult[`${realm}_los_token`];
        }

        return authResult;
    } catch (error) {
        console.error('Authentication check failed:', error);
        return { isAuthenticated: false };
    }
};
